// libs
import get from 'lodash/get';
import { ITEM_TYPES } from './constants';

// constants
export const CAV = 'cav';

export const getImpressionsProductData = (productData: Listing.IProduct) => {
  if (String(productData.type).toUpperCase() === ITEM_TYPES.TIPTILE) {
    return {};
  }

  return {
    event: 'product:impressions',
    product_name: get(productData, 'subTitle', ''),
    product_sku: get(productData, 'sku', ''),
    event_type: 'impression',
    product_mrp: get(productData, 'price', 0),
    product_position: get(productData, 'productIndex', 0),
    product_price: get(productData, 'price', 0),
    product_dp: get(productData, 'discountedPrice', 0),
    product_id: get(productData, 'id', ''),
    product_brand: get(productData, 'title', ''),
    product_tags: get(productData, 'tag', []).map((item) => item?.title),
    listing_position: get(productData, 'listingPosition', 0),
  };
};

export const getIsCAVClickRedirectedPage = () => {
  if (!window) return false;

  const searchParams = new URLSearchParams(window.location.search);

  return searchParams.get('intcmp')?.split(',')[1] == CAV;
};

export const canShowCoachmark = (productPosition: number, isHybridPage: boolean) => {
  // for hybrid page, first scroll view after widgets would be 1st row, hence the value 0 [representing 1st product card]
  // for normal pages, first scroll view would be 3rd row, hence the value 4 [representing 5th product card]

  return isHybridPage ? productPosition === 0 : productPosition === 4;
};
